import React, { useState, useEffect } from "react";
import moment from "moment";
import {
  Container,
  Row,
  Col,
  Button,
  Breadcrumb,
  Tab,
  Nav,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  blockUnblockUser,
  convertToIrs,
  deleteUserDocument,
  documentCategoryList,
  editCustomer,
  postDocumentFile,
  rowSorting,
  sendDocumentList,
  sendEmail,
} from "../../../store/actions";
import {
  DataTable,
  DataTableBody,
  DataTableHead,
} from "../../../Common/DataTable";
import { Link } from "react-router-dom";
import { MenuItem, Select } from "@material-ui/core";

const addressColumnData = [
  { id: "_id", align: false, disablePadding: true, label: "#", order: 1 },
  {
    id: "name",
    align: false,
    disablePadding: true,
    label: "Document Name",
    title: "name",
    order: 1,
  },

  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
    title: "status",
    type: "tag",
    order: 1,
  },

  {
    id: "action",
    align: true,
    disablePadding: false,
    title: "action",
    label: "Action",
  },
];

const ViewCustomerProfile = () => {
  const dispatch = useDispatch();
  const id = location.pathname.split("/")[3];
  const backLink = "/customers/profile/" + id;
  const [state, setState] = useState("all");
  const [docData, setDocData] = useState([]);
  const userData = useSelector((s) => s?.Customers?.edituser?.data);
  const loading = useSelector((s) => s?.Customers?.loading);
  const [showDoc, setShowDoc] = useState(false);
  const [addData, setAddData] = useState({
    title: "",
    document_categories_id: "",
  });
  const Categories = useSelector((s) => s.DocumentCategories?.categories?.data);
  const [Additional, setAdditional] = useState({
    open: "",
    data: "",
  });
  const [Delete, setDelete] = useState({
    open: false,
    dumpId: "",
  });
  const [addressState, setAddressState] = useState({
    columns: addressColumnData,
    rowsPerPage: 5,
    page: 0,
    order: -1,
    orderBy: "createdAt",
  });

  const [data, setData] = useState({
    customerId: "",
    userName: "",
    email: "",
    mobileNumber: "",
    profileImage: "",
    status: "",
    createdAt: "",
    avgRating: "",
    countryCode: "",
    fullName: "",
    totalBookingsCount: 0,
    totalBookingsRevenue: 0,
    addresses: [],
    upcomingBookings: [],
    pastBookings: [],
    vehicles: [],
    profile_image: "",
  });

  useEffect(() => {
    dispatch(documentCategoryList());
  }, []);

  useEffect(() => {
    setData((pre) => ({
      ...pre,
      userName:
        userData?.amtaxsettlement_data?.FirstName +
          " " +
          userData?.amtaxsettlement_data?.LastName || "--",
      email: userData?.amtaxsettlement_data?.Email || "--",
      mobileNumber: userData?.amtaxsettlement_data?.CellPhone || "--",
      profile_image: (userData && userData["0"]?.profile_image) || "",
      profileImage: userData?.profileImage,
      status: userData?.status,
      createdAt: userData?.createdAt,
      avgRating: userData?.avgRating,
      countryCode: userData?.amtaxsettlement_data?.CellCode,
      address: userData?.address,
      upcomingBookings: userData?.upcomingBookings,
      pastBookings: userData?.pastBookings,
      vehicles: userData?.vehicles,
    }));
    setDocData(userData?.documents);
  }, [userData]);

  useEffect(() => {
    if (id) {
      dispatch(editCustomer(id));
    }

    setData((pre) => ({
      ...pre,
      customerId: id,
    }));
  }, [id]);

  const Block_unblock_User = (status) => {
    const callBack = (res) => {
      if (res.status == 200) {
        toast.success("Success!");
        dispatch(editCustomer(id));
      } else {
        toast.error("");
      }
    };

    dispatch(blockUnblockUser({ userId: id, status: status }, callBack));
  };

  const handleSendDocuments = () => {
    const callback = (res) => {
      if (res.data) {
        toast.success("Documents Sent via mail");
      } else {
      }
    };
    dispatch(sendDocumentList(id, callback));
  };

  const handleTabChange = (value) => {
    setState(value);
    if (value == "all") {
      setDocData(userData?.documents);
    } else if (value == "pending") {
      setDocData(
        userData?.documents.filter((item) => item.status == "pending")
      );
    } else if (value == "submitted") {
      setDocData(
        userData?.documents.filter((item) => item.status == "submitted")
      );
    } else if (value == "accepted") {
      setDocData(
        userData?.documents.filter((item) => item.status == "accepted")
      );
    } else if (value == "rejected") {
      setDocData(
        userData?.documents.filter((item) => item.status == "rejected")
      );
    }
  };

  const handleDragEnd = (e) => {
    if (!e.destination) return;
    let tempData = Array.from(docData);
    let [source_data] = tempData.splice(e.source.index, 1);
    tempData.splice(e.destination.index, 0, source_data);
    setDocData(tempData);

    let body = {
      id: e?.draggableId,
      current_index: JSON.stringify(e?.source?.index),
      destination_index: JSON.stringify(e?.destination?.index),
      action_on: "user_detail",
    };
    dispatch(rowSorting(body));
  };

  const handleConvertUser = (e) => {
    e.preventDefault();

    const callback = (res) => {
      if (res.data) {
        toast.success("User Data Converted to IRS");
      } else {
        toast.error(res.detail);
      }
    };

    dispatch(convertToIrs({ user_id: userData?.id }, callback));
  };

  const handleAddDoc = (e) => {
    e.preventDefault();
    const callBack = (res) => {
      if (res.data) {
        toast.success("Added Successfully");
        setShowDoc(false);
        setAddData({ title: "", document_categories_id: "" });
        setAdditional({ open: "", data: "" });
        dispatch(editCustomer(id));
      }
    };
    const editCallBack = (res) => {
      if (res.data) {
        toast.success("Updated Successfully");
        setShowDoc(false);
        setAddData({
          title: "",
          document_categories_id: "",
        });
        setAdditional({ open: "", data: "" });
        dispatch(editCustomer(id));
      }
    };
    if (Additional.data) {
      dispatch(
        postDocumentFile(
          {
            user_id: id,
            id: Additional?.data?.id,
            name: addData.title,
            document_categories_id: JSON.stringify([
              addData.document_categories_id,
            ]),
            status: Additional?.data?.status,
          },
          editCallBack
        )
      );
    } else {
      dispatch(
        postDocumentFile(
          {
            user_id: id,
            name: addData.title,
            document_categories_id: JSON.stringify([
              addData.document_categories_id,
            ]),
            status: "pending",
          },
          callBack
        )
      );
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setAddData((pre) => ({ ...pre, [name]: value }));
  };

  const AdditionalPop = (state, item) => {
    setAdditional((pre) => ({
      ...pre,
      open: state,
      data: item,
    }));
    setAddData({
      title: item.name,
      document_categories_id: JSON.parse(item.document_categories_id)[0],
    });
    setShowDoc(true);
  };

  const handleClosePop = () => {
    setShowDoc(false);
    setAddData({ title: "", document_categories_id: "" });
    setAdditional({ open: "", data: "" });
  };

  const DeletePopup = (state, id = "") => {
    setDelete((pre) => ({
      ...pre,
      open: state,
      dumpId: id,
    }));
  };

  const handleDelete = (e) => {
    const callBack = (res) => {
      if (res.data) {
        toast.success("Deleted Successfully!");
        setDelete(false);
        dispatch(editCustomer(id));
      }
    };
    dispatch(deleteUserDocument(Delete.dumpId, callBack));
  };

  const sendLinkEmail = (e) => {
    e.preventDefault();

    const callback = (res) => {
      if (res.message == "success") {
        toast.success("Link Sent Via mail successfully");
      } else {
        toast.error(res.error);
      }
    };
    dispatch(
      sendEmail(
        {
          user_id: id,
          email_content: `<p>Hello,</p>\n\n<p>Your Financial questionnaire link is here:</p>\n\n<p>https://clientportal.americantaxsettlement.com/client/financial-form</p>\n`,
          email_template_id: "",
          admin_id: localStorage && localStorage.getItem("id"),
        },
        callback
      )
    );
  };

  return (
    <>
      <Modal
        show={Delete.open}
        onHide={() => {
          setDelete(false);
        }}
        className="deleteAdd-pop delete-pop"
        centered
      >
        <Modal.Body>
          <div className="text-center py-3">
            <div className="icn my-3">
              <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M256,0C114.497,0,0,114.507,0,256c0,141.503,114.507,256,256,256c141.503,0,256-114.507,256-256    C512,114.497,397.493,0,256,0z M256,472c-119.393,0-216-96.615-216-216c0-119.393,96.615-216,216-216    c119.393,0,216,96.615,216,216C472,375.393,375.385,472,256,472z"
                  fill="#f8c886"
                ></path>
                <path
                  d="M256,128.877c-11.046,0-20,8.954-20,20V277.67c0,11.046,8.954,20,20,20s20-8.954,20-20V148.877    C276,137.831,267.046,128.877,256,128.877z"
                  fill="#f8c886"
                ></path>
                <circle cx="256" cy="349.16" r="27" fill="#f8c886"></circle>{" "}
              </svg>
            </div>
            <h2 className="pop-head m-0 pb-2">Are you Sure?</h2>
            <div className="btn-wrap my-2 d-flex align-items-center justify-content-center mt-3">
              <div className="pe-2 w-50">
                <Button
                  className="btn-2 w-100 d-flex align-items-center justify-content-center"
                  onClick={() => {
                    setDelete(false);
                  }}
                >
                  No Cancel!
                </Button>
              </div>
              <div className="pe-2 w-50">
                <Button
                  onClick={handleDelete}
                  className=" w-100 d-flex align-items-center justify-content-center"
                >
                  Yes, Delete it
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showDoc}
        onHide={handleClosePop}
        className="deleteAdd-pop delete-pop add-doc-pop"
        centered
      >
        <Modal.Body>
          <div className="text-center py-3">
            {/* <h2 className="pop-head m-0 pb-2">Add Document</h2> */}

            <Row>
              <Col lg="12" className="my-2">
                <label htmlFor="" className="form-label2 m-0">
                  Document Title
                </label>
                <input
                  type="text"
                  name="title"
                  value={addData.title}
                  onChange={handleChange}
                  placeholder=""
                  className="form-control"
                />
              </Col>
              <Col lg="12" className="my-2 doc-select">
                <label htmlFor="" className="form-label2 m-0">
                  Document Category
                </label>
                <Select
                  className="demo-simple-select-label"
                  id="demo-simple-select"
                  name="document_categories_id"
                  value={addData.document_categories_id}
                  onChange={handleChange}
                  MenuProps={Categories}
                >
                  {Categories &&
                    Categories.length > 0 &&
                    Categories.map((item, idx) => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                </Select>
              </Col>
            </Row>
            <div className="btn-wrap my-2 d-flex align-items-center justify-content-center mt-3">
              <div className="pe-2 w-50">
                <Button
                  className="btn-2 w-100 d-flex align-items-center justify-content-center"
                  onClick={handleClosePop}
                >
                  Cancel
                </Button>
              </div>
              <div className="pe-2 w-50">
                <Button
                  onClick={handleAddDoc}
                  className=" w-100 d-flex align-items-center justify-content-center"
                  disabled={addData == "" ? true : false}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <section className="dashboard profile-main py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item href="/customers">Accounts</Breadcrumb.Item>
                  <Breadcrumb.Item active>Details</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
            <Col lg="4" className="my-2">
              <div className="py-2">
                <div className="bg-white card-box pb-3 rounded">
                  <div className="cover-profile-wrp position-relative">
                    <div
                      className="cover-profile position-relative text-end rounded"
                      style={{
                        backgroundColor: "#34c38f40",
                      }}
                    >
                      <img
                        src="/assets/images/cover-vector.png"
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="px-3 d-flex align-items-center profile-view">
                      <div className="img-wrp me-2 rounded-circle p-1">
                        <img
                          src={
                            data?.profile_image
                              ? data?.profile_image
                              : "/assets/images/dummy-profile"
                          }
                          alt=""
                          className="h-100 w-100 profile-view-img img-fluid rounded-circle"
                        />
                      </div>
                      <div className="content">
                        <h6 className="m-0 fw-sbold text-capitalize">
                          {data?.userName}
                        </h6>
                      </div>
                    </div>
                  </div>
                  <ul className="list-unstyled px-3 mb-0 d-flex align-items-center justify-content-between py-2 profile-featured">
                    <li className="px-2 w-33">
                      <h4 className="m-0 pb-1">
                        {" "}
                        {moment(data?.createdAt).format("DD-MM-YYYY")}
                      </h4>
                      <p className="text-muted m-0 py-1">Member Since</p>
                    </li>
                    <li className="px-2 text-center w-33">
                      <h4 className="m-0 pb-1">
                        {" "}
                        {data?.status == "block" ? "Blocked" : "Active"}
                      </h4>
                      <p className="text-muted m-0 py-1">Status</p>
                    </li>
                  </ul>
                  <div className="py-2 px-3 d-flex align-items-center justify-content-between">
                    {data?.status == "active" ? (
                      <Button
                        onClick={(e) => Block_unblock_User("block")}
                        variant="danger"
                        className="small-btn"
                      >
                        Block
                      </Button>
                    ) : (
                      <Button
                        onClick={(e) => Block_unblock_User("active")}
                        variant="success"
                        className="small-btn"
                      >
                        Unblock
                      </Button>
                    )}
                    <ul className="list-unstyled social-links ps-0 mb-0 d-flex align-items-center justify-content-end gap-10">
                      <li className="">
                        <OverlayTrigger
                          delay={{ hide: 450, show: 300 }}
                          overlay={(props) => (
                            <Tooltip {...props}>Send Mail</Tooltip>
                          )}
                          placement="top"
                        >
                          <Link
                            to={`/customers/detail/mail/${id}`}
                            className="btn d-inline-flex align-items-center justify-content-center "
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                            >
                              <path
                                d="M12.5417 4.95133V9.84375C12.5417 10.6896 11.8562 11.375 11.0104 11.375H2.98958C2.58347 11.375 2.19399 11.2137 1.90682 10.9265C1.61966 10.6393 1.45833 10.2499 1.45833 9.84375V4.95133L6.82441 7.903C6.93379 7.96308 7.06649 7.96308 7.17558 7.903L12.5417 4.95133ZM11.0104 2.625C11.4101 2.62504 11.794 2.78138 12.08 3.06063C12.366 3.33987 12.5315 3.71989 12.5411 4.1195L6.99999 7.16742L1.45891 4.11921L1.45949 4.09296C1.47583 3.69812 1.64418 3.32488 1.92934 3.05129C2.21451 2.77771 2.5944 2.62496 2.98958 2.625H11.0104Z"
                                fill="#515463"
                              />
                            </svg>
                          </Link>
                        </OverlayTrigger>
                      </li>
                      <li className="">
                        <OverlayTrigger
                          delay={{ hide: 450, show: 300 }}
                          overlay={(props) => (
                            <Tooltip {...props}>Send SMS</Tooltip>
                          )}
                          placement="top"
                        >
                          <Link
                            to={`/customers/detail/sms/${id}`}
                            // state={{ backLink: `${key.backUrl?.backLink}` }}
                            className="btn d-inline-flex align-items-center justify-content-center "
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                            >
                              <path
                                d="M4.66699 6.41669C4.83227 6.41669 4.97091 6.36069 5.08291 6.24869C5.19491 6.13669 5.25071 5.99824 5.25033 5.83335C5.25033 5.66808 5.19433 5.52944 5.08233 5.41744C4.97033 5.30544 4.83188 5.24963 4.66699 5.25002C4.50171 5.25002 4.36308 5.30602 4.25108 5.41802C4.13908 5.53002 4.08327 5.66847 4.08366 5.83335C4.08366 5.99863 4.13966 6.13727 4.25166 6.24927C4.36366 6.36127 4.5021 6.41708 4.66699 6.41669ZM7.00033 6.41669C7.1656 6.41669 7.30424 6.36069 7.41624 6.24869C7.52824 6.13669 7.58405 5.99824 7.58366 5.83335C7.58366 5.66808 7.52766 5.52944 7.41566 5.41744C7.30366 5.30544 7.16521 5.24963 7.00033 5.25002C6.83505 5.25002 6.69641 5.30602 6.58441 5.41802C6.47241 5.53002 6.4166 5.66847 6.41699 5.83335C6.41699 5.99863 6.47299 6.13727 6.58499 6.24927C6.69699 6.36127 6.83544 6.41708 7.00033 6.41669ZM9.33366 6.41669C9.49894 6.41669 9.63757 6.36069 9.74957 6.24869C9.86157 6.13669 9.91738 5.99824 9.91699 5.83335C9.91699 5.66808 9.86099 5.52944 9.74899 5.41744C9.63699 5.30544 9.49855 5.24963 9.33366 5.25002C9.16838 5.25002 9.02974 5.30602 8.91774 5.41802C8.80574 5.53002 8.74994 5.66847 8.75033 5.83335C8.75033 5.99863 8.80633 6.13727 8.91833 6.24927C9.03033 6.36127 9.16877 6.41708 9.33366 6.41669ZM1.16699 12.8334V2.33335C1.16699 2.01252 1.28133 1.73777 1.50999 1.5091C1.73866 1.28044 2.01321 1.1663 2.33366 1.16669H11.667C11.9878 1.16669 12.2626 1.28102 12.4912 1.50969C12.7199 1.73835 12.834 2.01291 12.8337 2.33335V9.33335C12.8337 9.65419 12.7193 9.92894 12.4907 10.1576C12.262 10.3863 11.9874 10.5004 11.667 10.5H3.50033L1.16699 12.8334Z"
                                fill="#515463"
                              />
                            </svg>
                          </Link>
                        </OverlayTrigger>
                      </li>
                      <li className="">
                        <OverlayTrigger
                          delay={{ hide: 450, show: 300 }}
                          overlay={(props) => (
                            <Tooltip {...props}>Make Call</Tooltip>
                          )}
                          placement="top"
                        >
                          <a
                            href={`tel:${data.mobileNumber}`}
                            className="btn d-inline-flex align-items-center justify-content-center"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M19.95 21C17.8667 21 15.8083 20.5457 13.775 19.637C11.7417 18.7283 9.89167 17.441 8.225 15.775C6.55833 14.1083 5.271 12.2583 4.363 10.225C3.455 8.19167 3.00067 6.13333 3 4.05C3 3.75 3.1 3.5 3.3 3.3C3.5 3.1 3.75 3 4.05 3H8.1C8.33333 3 8.54167 3.07933 8.725 3.238C8.90833 3.39667 9.01667 3.584 9.05 3.8L9.7 7.3C9.73333 7.56667 9.725 7.79167 9.675 7.975C9.625 8.15833 9.53333 8.31667 9.4 8.45L6.975 10.9C7.30833 11.5167 7.704 12.1123 8.162 12.687C8.62 13.2617 9.12433 13.816 9.675 14.35C10.1917 14.8667 10.7333 15.346 11.3 15.788C11.8667 16.23 12.4667 16.634 13.1 17L15.45 14.65C15.6 14.5 15.796 14.3873 16.038 14.312C16.28 14.2367 16.5173 14.216 16.75 14.25L20.2 14.95C20.4333 15.0167 20.625 15.1377 20.775 15.313C20.925 15.4883 21 15.684 21 15.9V19.95C21 20.25 20.9 20.5 20.7 20.7C20.5 20.9 20.25 21 19.95 21Z"
                                fill="#515463"
                              />
                            </svg>
                          </a>
                        </OverlayTrigger>
                      </li>
                    </ul>
                  </div>
                  <div className="btn-doc-div ps-3 btns-convert-text pe-3">
                    <Button
                      className="send-doc-btn m-2"
                      onClick={handleSendDocuments}
                    >
                      Send Owed Documents to Client
                    </Button>
                    <div className="d-flex justify-content-between">
                      <Button
                        className=""
                        onClick={handleConvertUser}
                        disabled={
                          userData && userData[0]?.convert_to_user == "0"
                            ? false
                            : true
                        }
                      >
                        Convert to IRS
                      </Button>
                      <Link
                        className="btn cstm-link-btn"
                        to={`/finance-form/edit/${id}`}
                      >
                        Financial Questionnaire
                      </Link>
                    </div>
                    <div className="notes-link mt-2">
                      <Link
                        to={`/customers/notes/${id}`}
                        className="btn cstm-link-btn"
                      >
                        Notes
                      </Link>
                      <Link
                        to={`/customers/sms-history/${id}`}
                        className="btn cstm-link-btn ms-2"
                      >
                        SMS History
                      </Link>
                      <Link
                        to={`/customers/draft-email/${id}`}
                        className="btn cstm-link-btn ms-2"
                      >
                        Email History
                      </Link>
                      <Button className="btn ms-2 mt-2" onClick={sendLinkEmail}>
                        Send Financial Link
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="py-2">
                <div className="bg-white px-4 py-3 card-box rounded">
                  <div className="top d-flex align-items-start justify-content-between">
                    <h4 className="dashboard-head m-0">Personal Information</h4>
                  </div>
                  <div className="table-responsive py-3">
                    <table className="table common-table">
                      <tbody>
                        <tr>
                          <td>
                            <p className="m-0 fw-sbold"> Full Name :</p>
                          </td>
                          <td>
                            <p className="m-0 text-capitalize">
                              {" "}
                              {data?.userName}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p className="m-0 fw-sbold">Cell Phone : </p>
                          </td>
                          <td>
                            <p className="m-0">{data?.mobileNumber}</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p className="m-0 fw-sbold">Email :</p>
                          </td>
                          <td>
                            <p className="m-0">{data?.email}</p>
                          </td>
                        </tr>
                        <tr></tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg="8" className="my-2">
              <div className="py-2">
                <Tab.Container id="left-tabs-example" defaultActiveKey={state}>
                  <Nav
                    variant="pills"
                    className="bg-white mb-3 commonTabs viewprofile"
                  >
                    <Nav.Item>
                      <Nav.Link
                        className="bg-transparent border-0 py-3 position-relative px-3"
                        eventKey="all"
                        onClick={() => handleTabChange("all")}
                      >
                        All
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className="bg-transparent border-0 py-3 position-relative px-3"
                        eventKey="pending"
                        onClick={() => handleTabChange("pending")}
                      >
                        Pending
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className="bg-transparent border-0 py-3 position-relative px-3"
                        eventKey="Submitted"
                        onClick={() => handleTabChange("submitted")}
                      >
                        Submitted
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className="bg-transparent border-0 py-3 position-relative px-3"
                        eventKey="Accepted"
                        onClick={() => handleTabChange("accepted")}
                      >
                        Accepted
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className="bg-transparent border-0 py-3 position-relative px-3"
                        eventKey="Rejected"
                        onClick={() => handleTabChange("rejected")}
                      >
                        Rejected
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <div className="text-end m-2">
                    <Button onClick={() => setShowDoc(true)}>
                      Add Document
                    </Button>
                  </div>
                  <div className="bg-white px-4 py-3 card-box rounded">
                    <div className="top d-flex align-items-start justify-content-between">
                      <h4 className="dashboard-head m-0">Documents</h4>
                    </div>
                    <div className="address-wrp">
                      <div className="py-2">
                        <div className="cstm-card tax-table-responsive">
                          <DragDropContext onDragEnd={handleDragEnd}>
                            <DataTable>
                              <DataTableHead
                                columns={addressColumnData}
                                orderBy={addressState.orderBy}
                                // sort={this.handleRequestSort}
                              />
                              <Droppable droppableId="droppable-1">
                                {(provider) => (
                                  <DataTableBody
                                    loading={loading}
                                    column={addressColumnData}
                                    data={docData}
                                    page={addressState.page}
                                    rowsPerPage={addressState.rowsPerPage}
                                    innerRef={provider.innerRef}
                                    dropProp={provider.droppableProps}
                                    actionBtn={[
                                      {
                                        label: "Upload",
                                        icon: "",
                                        link: `/customers/document/upload/${id}`,
                                        backUrl: { backLink },
                                      },
                                      {
                                        label: "ViewDoc",
                                        icon: "",
                                        link: `/customers/document/view/${id}`,
                                        backUrl: { backLink },
                                      },
                                      {
                                        label: "Additional",
                                        icon: "",
                                        action: AdditionalPop,
                                      },
                                      {
                                        label: "Delete",
                                        icon: "",
                                        action: DeletePopup,
                                      },
                                    ]}
                                  />
                                )}
                              </Droppable>
                            </DataTable>
                          </DragDropContext>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab.Container>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default ViewCustomerProfile;
